import { render, staticRenderFns } from "./boxList.vue?vue&type=template&id=2bbcb336&scoped=true&"
import script from "./boxList.vue?vue&type=script&lang=js&"
export * from "./boxList.vue?vue&type=script&lang=js&"
import style0 from "./boxList.vue?vue&type=style&index=0&id=2bbcb336&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcb336",
  null
  
)

export default component.exports